import React from 'react';

import PropTypes from 'prop-types';

import { Text } from '@adsk/alloy-react-box';
import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

export type CommentTextProps = StylableComponent<HTMLDivElement> & {
  comment: string;
  detectUrls?: boolean;
  showUrlsIcons?: boolean;
};

const CommentText = React.forwardRef<HTMLDivElement, CommentTextProps>(
  (
    {
      style,
      className,
      comment,
      detectUrls = true,
      showUrlsIcons = true,
      ...props
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={className}
      css={[
        theme.typography.bodyMedium,
        {
          padding: `${theme.spacing.S}px ${theme.spacing.M}px`,
          color: theme.tokens.colors.text.primary.value,
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        },
        style,
      ]}
      {...props}
    >
      <Text detectUrls={detectUrls} showUrlsIcons={showUrlsIcons}>
        {comment}
      </Text>
    </div>
  ),
);

CommentText.displayName = 'CommentText';

CommentText.propTypes = {
  /** Styles applied to the comment text element */
  style: stylePropType,
  /** Class applied to the comment text element */
  className: PropTypes.string,
  /* The comment text */
  comment: PropTypes.string.isRequired,
  /** Whether to automatically detect and render URLs as links with an icon (enabled by default) */
  detectUrls: PropTypes.bool,
  /** Whether to show icons next to URLs (enabled by default) */
  showUrlsIcons: PropTypes.bool,
};

export default CommentText;
